<template>
  <a-modal
    title="选择成员"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    width="580px"
    :forceRender="true"
  >
    <div class="content_box">
      <div class="div_box">
        <div class="box_top">可选({{ selectList.length }})</div>
        <div class="box_input">
          <a-input-search
            placeholder="请输入关键词搜索"
            style="width: 100%"
            @search="onSearch"
          />
        </div>
        <div class="select_list select_list1">
          <div class="list_item">
            <a-checkbox @change="allChange" :checked="allChecked" :value="-1">
            </a-checkbox>
            全选
          </div>
          <div v-for="item in selectList" :key="item.value" class="list_item">
            <a-checkbox
              @change="onChange1(item, $event)"
              :checked="item.checked"
            >
            </a-checkbox>
            {{ item.lable }}
          </div>
        </div>
      </div>
      <div class="div_box">
        <div class="box_top">已选({{ hasSelectList.length }})</div>
        <div class="select_list select_list2">
          <div
            v-for="item in hasSelectList"
            :key="item.value"
            class="list_item"
          >
            <a-checkbox
              :checked="item.checked"
              @change="onChange2(item, $event)"
            >
            </a-checkbox>
            {{ item.lable }}
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { shareGzhLocal } from "@/request/api";
export default {
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      },
    },
    showList: {
      type: Array,
      default() {
        return [];
      },
    },
    id: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      confirmLoading: false,
      list: [],
      selectList: [],
      hasSelectList: [],
      allChecked: false,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.list = JSON.parse(JSON.stringify(this.showList));
        this.selectList = JSON.parse(JSON.stringify(this.showList));
        this.allChecked = false;
      }
    },
  },

  methods: {
    async shareGzh() {
      this.confirmLoading = true;
      try {
        const admin_id = this.hasSelectList.map((item) => item.value);
        const result = await shareGzhLocal({
          admin_id,
          id: this.id,
        });
        const codes = [0, 200, 8011];
        if (codes.includes(result.data.code)) {
          this.$message.success(`分享成功`);
          this.handleCancel();
        } else {
          this.$message.error(result.data.msg || "");
        }
      } catch (error) {
        this.confirmLoading = false;
      } finally {
        this.confirmLoading = false;
      }
    },
    handleOk() {
      const ids = this.hasSelectList.map((item) => item.value);
      if (ids.length === 0) {
        this.$message.warning(`未选择成员`);
        return;
      }
      this.shareGzh();
    },
    handleCancel() {
      this.resetStatus();
      this.$emit("cancelClick");
    },
    onSearch(e) {
      const list = JSON.parse(JSON.stringify(this.list));
      if (!e) {
        this.selectList = list;
        return;
      }
      this.selectList = list.filter((item) => item.lable.includes(e));
    },
    allChange(val) {
      const _selectList = JSON.parse(JSON.stringify(this.selectList)); //复制
      const temp = _selectList.map((item) => {
        return {
          ...item,
          checked: val.target.checked,
        };
      });
      if (val.target.checked) {
        this.selectList = JSON.parse(JSON.stringify(temp));
        this.hasSelectList = JSON.parse(JSON.stringify(temp));
      } else {
        this.selectList = JSON.parse(JSON.stringify(temp));
        this.hasSelectList = [];
      }
      this.allChecked = val.target.checked;
    },
    // 左侧
    onChange1(item, event) {
      const { value } = item;
      const _selectList = JSON.parse(JSON.stringify(this.selectList)); //复制
      const copyList = JSON.parse(JSON.stringify(this.list));
      const copyItem = copyList.find((item) => item.value === value);
      const leftItem = _selectList.find((item) => item.value === value); // 当前操作的数据
      //   选中
      if (event.target.checked) {
        const _item = this.hasSelectList.find((item) => item.value === value);
        if (!_item && leftItem) {
          leftItem.checked = true;
          this.hasSelectList.push(leftItem);
        }
      } else {
        // 取消
        const temp = JSON.parse(JSON.stringify(this.hasSelectList));
        this.hasSelectList = temp.filter((item) => item.value != value);
      }
      if (leftItem) {
        leftItem.checked = event.target.checked;
      }
      if (copyItem) {
        copyItem.checked = event.target.checked;
      }
      this.selectList = JSON.parse(JSON.stringify(_selectList));
      this.list = JSON.parse(JSON.stringify(copyList));
      this.allChecked =
        this.hasSelectList.length > 0 &&
        this.hasSelectList.length === this.selectList.length;
    },
    // 右侧只有取消
    onChange2(item) {
      const { value } = item;
      const _selectList = JSON.parse(JSON.stringify(this.selectList));
      const copyList = JSON.parse(JSON.stringify(this.list));
      const _item = _selectList.find((item) => item.value === value);
      const copyItem = copyList.find((item) => item.value === value);
      if (_item) {
        _item.checked = false;
      }
      if (copyItem) {
        copyItem.checked = false;
      }
      this.selectList = JSON.parse(JSON.stringify(_selectList));
      this.list = JSON.parse(JSON.stringify(copyList));
      const _hasSelectList = JSON.parse(JSON.stringify(this.hasSelectList));
      this.hasSelectList = _hasSelectList.filter(
        (item) => item.value !== value
      );
    },
    resetStatus() {
      const list = JSON.parse(JSON.stringify(this.list));
      const temp = list.map((item) => {
        return {
          ...item,
          checked: false,
        };
      });
      this.list = JSON.parse(JSON.stringify(temp));
      this.selectList = JSON.parse(JSON.stringify(temp));
      this.hasSelectList = [];
    },
  },
};
</script>
<style scoped>
.content_box {
  display: flex;
  justify-content: space-between;
}
.div_box {
  width: 48%;
  border: 1px solid #cecece;
  border-radius: 8px;
  overflow: hidden;
}
.box_top {
  background-color: #efefef;
  font-weight: bold;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
}
.box_input {
  padding: 0 10px;
  margin-top: 10px;
}

.select_list {
  overflow: scroll;
  padding: 0 10px;
  margin-top: 10px;
}
.select_list.select_list1 {
  height: 200px;
}
.select_list.select_list2 {
  height: 240px;
}
.list_item {
  margin-bottom: 8px;
}
::-webkit-scrollbar {
  /* height决定横向scrollbar的高度，width决定纵向滚动条的宽度 */
  height: 7px;
  width: 7px;
  background-color: #fff;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #ccc;
}
</style>
